import { IAnalyticsMessage } from '../../types';
import { eventSiteHandler } from './eventSiteHandler';
import { pageviewSiteHandler } from './pageviewSiteHandler';

let latestPage: unknown;

export function analyticsMessageHandler(message: IAnalyticsMessage) {
  const [eventType] = message.value;
  switch (eventType) {
    case 'eventSite':
      eventSiteHandler(message.value, latestPage);
      break;

    case 'pageviewSite':
      pageviewSiteHandler(message.value);
      latestPage = message.value[1].page || null;
      break;
  }
}
